var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Flatfinder',{staticClass:"project-flatfinder",attrs:{"value":_vm.item.flatfinders,"properties":_vm.properties}})
}
var staticRenderFns = []

export { render, staticRenderFns }